import { ReactNode } from 'react';

import { useApi } from '@paradigm/api';
import { useEffectOnce } from '@paradigm/utils/src/hooks';

import { useGrfqService } from '#/unified-rfqs/contexts/grfqs';
import { createView, ViewCtx } from './details-view';

interface Props {
  readonly children: ReactNode;
  readonly tradeId: number;
}

export function TradeDetailsProvider({ children, tradeId }: Props) {
  const { getTrade } = useGrfqService();
  const [tradeFetch, fetchTradeDetails] = useApi(getTrade);

  const view = createView({ tradeFetch });

  useEffectOnce(() => {
    fetchTradeDetails({ tradeId });
  });

  return <ViewCtx.Provider value={view}>{children}</ViewCtx.Provider>;
}
